
import Form from 'react-bootstrap/Form';
import { useState } from "react";

function InputRemarks(props){
  const [placeholder, setPlaceholder] = useState("");
  const [maxLength, setMaxLength] = useState("");
  const [remarks, setRemarks] = useState("");
  const [isChinese, setIsChinese] = useState("");
  const [disabled, setDisabledRemarks] = useState(false);
 
  const LangHandleChange = (e) => {

      var lang = e.target.value;
      setRemarks("");
      setIsChinese("");
      props.handleClearimage_Generatation_Status();

     if (lang === "NA")
      {
        setDisabledRemarks(true);
      }
      else
      {
        setDisabledRemarks(false);
      }
    };

    const RemarksHandleChange = (e) => {
      const text = e.target.value;
      setRemarks(text);
      setIsChinese(containsChinese(text));
      props.handleClearimage_Generatation_Status();
    };

    function containsChinese(text) {
      const regexTraditional = new RegExp('^[\u4E00-\u9FFF]+$');
      const regexSimplified = new RegExp('^[\u3400-\u4DBF]+$');
      let isTCSC;
      if (text != "")
      {
        if (regexTraditional.test(text)) {
          isTCSC = "TCSC";
        } else if (regexSimplified.test(text)) {
          isTCSC = "TCSC";
        } else {
          isTCSC = "Other";
        }
      }
      else
      {
        isTCSC = "";
      }
      return isTCSC;
    }

    return <>
    <Form.Group className="mb-3" >
        {props.langList.map((lang) => <PrintRadio groupName={props.groupName} key={lang.id} description={lang.display} value={lang.value} passEvent={LangHandleChange} setLang={props.setLang}></PrintRadio>)} 
        <Form.Control type="text" disabled={disabled} onChange={ e => { props.setRemarks(e); RemarksHandleChange(e);}} value={remarks} placeholder="填寫姓氏" maxLength="2" />
        <div className="warning" style={{backgroundColor: 'yellow', fontWeight: 'bold' }}>
          {isChinese == "" ? "" : isChinese == "TCSC" ? (
            ""
          ) : (
            <p>輸入的資料不適用於訂製姓氏的範圍內，請重新輸入。</p>
          )}
        </div>
    </Form.Group>
  </>
}

function PrintRadio(props){
  return <><Form.Check inline="true" type="radio" name={props.groupName} label={props.description} value={props.value} onChange={ e => { props.setLang(e); props.passEvent(e)}}/></>
}


function FindArrayElementByValue(array, value) {
    return array.find((element) => {
      return element.value === value;
    })
  }

export default InputRemarks;